<template>
  <div>
    <el-table
      :data="data"
    >
      <el-table-column
        prop="id"
        label="ID"
      />
      <el-table-column
        prop="user_id"
        label="UID"
      />
      <el-table-column
        prop="amount"
        label="保额"
      />
      <el-table-column
        prop="fee"
        label="保费"
        :formatter="function(v) { return v['fee'] / 100 }"
      />
      <el-table-column
        prop="invite_reward"
        label="奖励状态"
        :formatter="function(v) { return v['invite_reward'] === 1 ? '已发放' : '未发放' }"
      />
      <el-table-column
        prop="id"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row['invite_reward'] === 0" size="mini" @click="handleSetReward(scope.row.id)">设置奖励</el-button>
          <el-button v-else size="mini" @click="handleShowReward(scope.row.id)">查看奖励</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pager
      api="order_get_list"
      :filter="filter"
      :sort="sort"
      @data-changed="onDataChanged"
    />
    <el-dialog :visible.sync="showReward">
      <el-row>
        <el-col :span="4">
          金额
        </el-col>
        <el-col :span="20">
          {{reward.amount / 100}}元
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          发放时间
        </el-col>
        <el-col :span="20">
          {{reward.time}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          奖励类型
        </el-col>
        <el-col :span="20">
          {{reward.category}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          奖励内容
        </el-col>
        <el-col :span="20">
          {{reward.type}}
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog :visible.sync="showSetReward">
      <el-form ref="searchForm" :model="dataSetReward">
        <el-form-item label="金额（元）">
          <el-input-number v-model.number="dataSetReward['amount']" size="mini" />
        </el-form-item>
        <el-form-item label="奖励类型">
          <el-select v-model="dataSetReward.category" size="mini">
            <el-option value="sv">卡密</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖励实体">
          <el-select v-model="dataSetReward.type" size="mini">
            <el-option value="jd">京东卡</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="冷静期">
          <el-date-picker v-model="dataSetReward.cooling_off" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="success" size="mini" @click="handleSendReward">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import Pager from "../ui/Pager"
  import request from "../../api/request"

  export default {
    name: 'PolicyList',
    components: { Pager },
    data () {
      return {
        data: [],
        filter: {},
        sort: [],
        dataSetReward: {},
        showReward: false,
        showSetReward: false,
        dataReward: {}
      }
    },
    computed: {
      reward: function () {
        const ret = {
          amount: this.dataReward.amount,
          time: this.dataReward.time
        }
        ret.category = this.dataReward.category === 'sv' ? '卡密' : '未知'
        ret.type     = this.dataReward.type === 'jd' ? '京东卡' : '未知'
        return ret
      }
    },
    methods: {
      onDataChanged: function (data) {
        this.data = data
      },
      handleShowReward: function (id) {
        this.getOrderReward(id)
      },
      handleSetReward: function (id) {
        this.showSetReward = true
        this.dataSetReward.order_id = id
      },
      handleSendReward: function() {
        this.$confirm('奖励设置后立即发给用户 不可撤回!!!', '确认发放奖励', {
          confirmButtonText: '发放奖励',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          request.front.post('order_set_reward', {
            id: this.dataSetReward.order_id,
            coupon_category: this.dataSetReward.category,
            coupon_type: this.dataSetReward.type,
            amount: this.dataSetReward.amount * 100,
            cooling_off: this.dataSetReward.cooling_off
          }).then(() => {
            this.$message.success('设置奖励成功')
          })
        }).finally(() => {
          this.showSetReward = false
          this.dataSetReward = {}
        })
      },
      getOrderReward: async function (id) {
        const resp = await request.activity.post('order_get_reward', {
          order_id: id
        })
        if(resp.status === 0) {
          this.dataReward = resp['data']
          this.showReward = true
        }
      }
    }
  }
</script>